import React from 'react';
import SVG from "react-inlinesvg"
import { Link, Image } from "rebass";

const SocialButton = (props) => {
  const { href, title, icon } = props
  const isSVG = icon.endsWith('.svg') ? SVG : Image;

  return (
    <Link
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      title={title}
      aria-label={title}
      sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        width: '38px',
        height: '38px',
        borderWidth: '1px',
        borderStyle: 'solid',
        borderColor: 'text',
        borderRadius: 'circle',
        color: 'text',
        position: 'relative',
        transition: "color 0ms 150ms linear",

        '::before': {
          content: '""',
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          bg: 'text',
          borderRadius: 'circle',
          transformOrigin: 'center center',
          transform: 'scale3d(0.0, 0.0, 0.0)',
          transition: 'transform 450ms cubic-bezier(0.475,0.425,0,0.995)',
        },
        ':hover,:focus,:active': {
          color: 'background',
          transition: "color 0ms 100ms linear",

          '::before': {
            transform: 'scale3d(1.0, 1.0, 1.0)',
          }
        }
      }}
      {...props}
    >
      {isSVG && (
        <SVG
          src={icon}
          title={title}
          description={title}
          preProcessor={code => code.replace(/fill=".*?"/g, 'fill="currentColor"')}
          aria-hidden="true"
          style={{
            position: 'relative',
          }}
        />
      )}
      {!isSVG && (
        <Image
          src={icon}
          sx={{
            position: 'relative',
          }}
          aria-hidden="true"
        />
      )}
    </Link>
  );
}

export default SocialButton;
